import React, {useRef, useState, useEffect} from 'react';
import loadable from '@loadable/component';
import {
  View,
  Text,
  Pressable,
  Dimensions,
  Modal,
  TouchableOpacity,
  Linking,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
// import Video from 'react-native-video';

import {selectrootsheettype} from '../../../../../selectors/SheetSelector';
import {isWeb} from '../../../../../constants';
import BottomSheet from 'src/components/bottom-sheet';
import {showSheet} from '../../../../../actions/SheetActions';
import styles from './AppLearn.style';
import EmptyBox from '../../../../../components/empty-box/EmptyBox.component';
import PrimaryButton from '../../../../../components/primary-button/PrimaryButton.component';
import {CustomText} from '../../../../../components/text/Text';
import FabBackButton from '../../../../../components/fab-back-button/FabBackButton.componet';
import {useHistory, useLocation} from '../../../../../imports/Router';

const SVG = loadable(() => import('../../../../../imports/svg'));
const height = Dimensions.get('window').height;
const windowWidth = Dimensions.get('window').width;
const aspectRatio = 1.3;
const AppLearn = () => {
  const bottomSheetRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const [visible, setVisible] = useState(false);
  const {t} = useTranslation();
  const selectedItem = useSelector(state => state.learn.selectedItem);

  const closeBottomSheet = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };
  const closeBottomSheet1 = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };
  const onSelect = () => {
    history.push('/main/dashboard/learn/VideoScreen');
    dispatch(
      showSheet({
        sheetId: '',
      }),
    );
  };
  return (
    <BottomSheet
      ref={bottomSheetRef}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [height * 0.98]}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(
                  showSheet({
                    sheetId: '',
                  }),
                );
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? height * 0.98 : undefined}
      open={sheetProps?.visible}
      isScrollView={isWeb ? undefined : true}
      handleIndicatorStyle={
        !isWeb ? {backgroundColor: 'transparent'} : undefined
      }
      onClose={closeBottomSheet1}>
      {console.log(selectedItem, 'selectedItem')}
      <View style={styles.container}>
        <View style={styles.header}>
          <FabBackButton
            container_style={styles.closeBtn}
            onPress={closeBottomSheet}
            icon={'closeIcon'}
          />
          <Text style={styles.headerTitle}>{selectedItem?.Title}</Text>
        </View>
        <View style={[{width: windowWidth, aspectRatio, marginTop: 15}]}>
          <SVG name={'AppLearn'} width={'100%'} height={'100%'} />

          <Text style={[styles.description]}>
            در نقشه وسیله نزدیک خود را انتخاب و رزرو کنید. وسیله ۵ دقیقه به صورت
            رایگان برای شما رزرو میشود تا به آن برسید.
          </Text>

          <Text style={styles.description2}>
            از سپردن حساب کاربری خود به دیگران جدا خودداری کنید
          </Text>
        </View>
        <EmptyBox height={height * 0.25} />
        <CustomText size={10} font={'400'} color={'#2e2e2eff'}>
          در ۳ دقیقه استفاده از اپلیکیشن را یاد بگیرید{' '}
        </CustomText>
        <PrimaryButton
          onPress={onSelect}
          containerStyle={styles.buttonContainer}>
          <>
            {console.log(selectedItem?.Link, 'selectedItem?.Link')}
            <TouchableOpacity
              onPress={() => {
                onSelect();
                //Linking.openURL(selectedItem?.Link)
              }}
              style={styles.reserveTextContainer}>
              <View style={styles.flexrow}>
                <View style={{paddingRight: 10}}>
                  <SVG
                    name={'PlayCircle1'}
                    width={17}
                    height={17}
                    color="#444"
                  />
                </View>
                <CustomText size={14} font={'500'} color={'#FFFFFF'}>
                  {t('see_video')}
                </CustomText>
              </View>
            </TouchableOpacity>
          </>
        </PrimaryButton>
      </View>
      {/* <Modal
        visible={visible}
        transparent
        animationType="slide"
        onRequestClose={() => setVisible(false)}>
        <View
          style={{
            flex: 1,
            backgroundColor: 'rgba(0,0,0,0.4)',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <View
            style={{
              backgroundColor: '#fff',
              padding: 16,
              borderRadius: 12,
            }}>
            <Pressable onPress={() => setVisible(false)}>
              <Text>Close</Text>
            </Pressable>
            <CrossPlatformVideo
              source={{
                uri: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
              }}
              controls
              style={{width: 300, height: 200}}
            />
          </View>
        </View>
      </Modal> */}
    </BottomSheet>
  );
};

export default AppLearn;
